// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // apiRoot: 'http://localhost:3001',
  apiRoot: "https://api.evento.sa",
  authRoot: "https://auth.evento.sa",
  // apiRoot: 'https://api-v2-fom53oib7a-ew.a.run.app',
  apiRootAdmin: "https://api.evento.sa/admin",
  defaultLanguage: "ar",
  title: "Falak | فلك ",
  MERCHANT_ID: "3000000011", // DEV
  MERCHANT_JS:
    "https://ksa.gateway.mastercard.com/checkout/version/56/checkout.js",
  CREATORID: "2ea7784a-39f6-4c46-a029-c777ad78c768",
  paymentRoot: "https://pay.evento.sa/payment",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
